/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import NProgress from 'nprogress';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';

import Config from '@config/Config';
import Session from '@/Session';
import GetInternalUserDetails from '@/services/GetInternalUserDetails';
// import GetConfigurations from '@/services/GetConfigurations';

import HandleOTDSRESTAuthentication from '../../services/HandleOTDSRESTAuthentication';
import InvalidCredentialsError from '../../errors/InvalidCredentialsError';

import './InternalLoginPage.css';
import tmplInternalLoginPage from './InternalLoginPage.hbs';

const InternalLoginPage = View.extend({
  template: tmplInternalLoginPage,

  className: 'internal-login-page',

  ui: {
    loginBtn: '.btn-login',
    username: '.username',
    password: '.password',
    invalidCredentialsError: '.invalid-credentials-error',
    generalError: '.general-error',
    btnCACLogin: '.btn-cac-login'
  },

  events: {
    'click @ui.loginBtn': 'handleLogin',
    'click @ui.btnCACLogin': 'onClickCACLogin'
  },

  templateContext() {
    return {
      dev: ENVIRONMENT === 'local.int',
      bannerText: Config.getBannerText()
    };
  },

  async onClickCACLogin(e) {
    e.preventDefault();
    window.location.href = Config.getInternalCACLogInUrl(window.location.href);
  },

  async handleLogin(e) {
    e.preventDefault();

    this.ui.invalidCredentialsError.hide();
    this.ui.generalError.hide();
    const spinner = Ladda.create(this.ui.loginBtn[0]);
    spinner.start();
    NProgress.start();

    try {
      const { username, password } = Syphon.serialize(this);
      this.ui.username.prop('disabled', true);
      this.ui.password.prop('disabled', true);
      await HandleOTDSRESTAuthentication(username, password);

      NProgress.set(0.6);

      const [profile] = await Promise.all([GetInternalUserDetails()]);
      Session.user = profile;
      Session.config = {};

      Radio.channel('global').trigger('login:finish');
    } catch (e) {
      if (e instanceof InvalidCredentialsError) {
        this.ui.invalidCredentialsError.slideDown(300);
      } else {
        this.ui.generalError.slideDown(300);
      }
      this.ui.username.prop('disabled', false);
      this.ui.password.prop('disabled', false);
      spinner.stop();
      NProgress.done();
    }
  }
});

export default InternalLoginPage;
